import { Navigate, Outlet } from 'react-router-dom';
import { useSession } from '@/store/useSession';
import { getLandingHomePath } from '@/lib/runtime';

export default function ProtectedRoute() {
    const { isAuthenticated, hasResolvedSession } = useSession();
    const landingHomePath = getLandingHomePath();

    if (!hasResolvedSession) {
        return null;
    }

    if (!isAuthenticated) {
        return <Navigate to={landingHomePath} replace />;
    }

    return <Outlet />;
}
